<ng-container *transloco="let t">
  @switch (error()) {
    @case (ErrorType.NOT_FOUND) {
      <ng-container
        [ngTemplateOutlet]="content"
        [ngTemplateOutletContext]="{
          caption: t('errorPage.notFound.caption'),
          header: t('errorPage.notFound.header'),
          description: t('errorPage.notFound.description'),
        }"
      ></ng-container>
    }
    @case (ErrorType.UNKNOWN) {
      <ng-container
        [ngTemplateOutlet]="content"
        [ngTemplateOutletContext]="{
          caption: t('errorPage.unknown.caption'),
          header: t('errorPage.unknown.header'),
          description: t('errorPage.unknown.description'),
        }"
      ></ng-container>
    }
    @case (ErrorType.AUTH_ERROR) {
      <ng-container
        [ngTemplateOutlet]="content"
        [ngTemplateOutletContext]="{
          caption: t('errorPage.auth.caption'),
          header: t('errorPage.auth.header'),
          description: t('errorPage.auth.description'),
        }"
      ></ng-container>
    }
  }
</ng-container>

<ng-template #content let-caption="caption" let-header="header" let-description="description">
  <section *transloco="let t">
    <div class="sm:grid sm:grid-cols-12">
      <div class="sm:col-span-6 sm:col-start-4">
        <h4 class="text-vermillon-500">{{ caption }}</h4>
        <h2 class="mt-xs">{{ header }}</h2>
        <p class="mt-6 font-normal">{{ description }}</p>
        <div class="mt-8">
          <a [routerLink]="linkService.homePath" class="btn w-48 btn-primary btn-elevated">
            {{ t('errorPage.home') }}
          </a>
        </div>
      </div>
    </div>
  </section>
</ng-template>
